import { useState } from "react";
import { saveAdvanceRequest } from "../Api/AdvanceRequest";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
//import "../Styling/AdvanceRequest.css";

const AdvanceRequest = () => {
  const [advanceData, setAdvanceData] = useState({
    purposeOfAdvance: "",
    destination: "",
    datesOfTravel: "",
    advanceAmountRequested: "",
    dateOfRequest: new Date().toISOString().split('T')[0], 
    approvalAuthority: "",
    modeOfAdvanceDisbursement: "",
    createdBy: localStorage.getItem("userId") || "" 
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdvanceData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const requestData = {
        ...advanceData,
        advanceAmountRequested: advanceData.advanceAmountRequested,
        datesOfTravel: advanceData.datesOfTravel,
        dateOfRequest: advanceData.dateOfRequest,
        createdBy: localStorage.getItem("userId")
      };

      console.log(requestData, 'requestData')
// return
      await saveAdvanceRequest(requestData);

      toast.success("Advance Request Submitted Successfully");
      
      setAdvanceData({
        purposeOfAdvance: "",
        destination: "",
        datesOfTravel: "",
        advanceAmountRequested: "",
        dateOfRequest: new Date().toISOString().split('T')[0],
        approvalAuthority: "",
        modeOfAdvanceDisbursement: "",
        createdBy: localStorage.getItem("userId") || "" 
      });
      
      // navigate("/viewAdvanceRequest");
    } catch (error) {
      console.error("Error submitting advance request:", error);
      toast.error(error.message || "Failed to submit advance request");
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Advance Request</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Purpose of Advance <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="purposeOfAdvance"
                    value={advanceData.purposeOfAdvance}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Destination <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="destination"
                    value={advanceData.destination}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Date of Travel <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="datesOfTravel"
                    value={advanceData.datesOfTravel}
                    onChange={handleChange}
                    required
                    min={new Date().toISOString().split('T')[0]}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Advance Amount (₹) <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="number"
                    name="advanceAmountRequested"
                    value={advanceData.advanceAmountRequested}
                    onChange={handleChange}
                    required
                    min="0"
                    step="0.01"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Date of Request <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="dateOfRequest"
                    value={advanceData.dateOfRequest}
                    onChange={handleChange}
                    required
                    max={new Date().toISOString().split('T')[0]} 
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Approval Authority <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="approvalAuthority"
                    value={advanceData.approvalAuthority}
                    onChange={handleChange}
                    required
                    placeholder="Enter approval authority"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Mode of Disbursement <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="modeOfAdvanceDisbursement"
                    value={advanceData.modeOfAdvanceDisbursement}
                    onChange={handleChange}
                    required
                    placeholder="Enter disbursement mode"
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button 
                variant="primary" 
                type="submit" 
                className="fields-submit" 
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit Request"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default AdvanceRequest;